import './public-content-page.scss';
import Box from '@mui/material/Box';

/**
 * HOC used around each public screen.
 */
export const PublicContentPage = (props: {children: React.ReactNode}) => {
  // Default result
  return (
    <Box
      className="public-content-page-container"
      sx={{
        // https://next.material-ui.com/customization/palette/
        bgcolor: 'background.paper',
      }}
    >
      <Box className="public-content-page-content">{props.children}</Box>
    </Box>
  );
};
